export const DEFAULT_LOGOUT_TIMEOUT = 60 * 60 * 1000; // TODO: get from API
export const DEFAULT_LOGOUT_TOAST_TIMEOUT = 5 * 60 * 1000; // TODO: get from API
export const INPUT_LISTENER_TIMEOUT = 60 * 1000;

export const TIMER_OFFSET = 1 * 1000;

export const LOGOUT_TIME_KEY = 'logoutTime';
export const TOAST_KEY = 'logoutNotify';
